<div *ngIf="!result" class="card mt-8">

   <h3 class="text-lg font-semibold pb-2 border-b">
      {{ invoicer_name }} <img src="assets/logos/logo_{{invoicer_name.toLowerCase()}}.png" class="inline h-8 ml-1">
      <!-- You can add a logo logic here if needed, similar to the EDE component -->
   </h3>
   
   <div class="tabs">
      <div class="tab active">Pagos</div>
   </div>

   <!-- Search Section -->
   <div class="mt-6">
      <div class="flex flex-col items-stretch flex-wrap md:flex-row md:items-baseline">
         <div class="mr-4 font-semibold">Cédula</div>
         <div class="flex-grow">
            <input id="nic" [(ngModel)]="id" (keydown.enter)="query()" type="text" inputmode="numeric"
               placeholder="Ingrese la cédula del cliente"
               class="py-2 px-2 w-full rounded border-0 border-b border-gray-300 md:py-0">
         </div>
      </div>
      
      <div class="flex gap-2 w-full mt-8 md:mt-3 md:w-max">
         <button (click)="query()" [disabled]="working.main || !id" class="btn btn-blue">
            Consultar
            <fa-icon icon="search" class="text-xs"></fa-icon>
            <working *ngIf="working.main"></working>
         </button>
      </div>
   </div>
</div>

<!-- Result / Payment Section -->
<div *ngIf="result" class="card w-full mt-8">
   <h3 class="text-lg font-semibold border-b">
      Resultado consulta
   </h3>
   
   <div class="mt-4 flex flex-col md:flex-row md:flex-wrap md:items-baseline">
      <div class="md:font-semibold w-44">Cédula:</div>
      <div class="font-semibold md:ml-4 md:font-normal">{{ result.document }}</div>
   </div>
   
   <div class="flex flex-col md:flex-row md:flex-wrap md:items-baseline">
      <div class="md:font-semibold w-44">Nombre del Cliente:</div>
      <div class="text-2xl font-semibold md:font-normal md:ml-4">{{ result.name }}</div>
   </div>

   <hr class="my-4">
   
   <div class="mt-4">
      <div class="font-semibold">Monto a pagar:</div>
      <div>
         <div>
            <span class="text-lg">RD$ </span>
            <input type="number" [(ngModel)]="amount" (keydown.enter)="amount && amount > 0 && amount < 20000 ? pay() : null" 
               placeholder="0.00"
               class="inline text-lg py-0 border-0 border-b border-gray-300 text-right outline-none focus:ring-0 w-32 px-0">
               
             <div *ngIf="amount >= 20000" class="text-red-500 text-sm mt-1">
                El monto debe ser menor a RD$ 20,000.00
             </div>
         </div>
         
         <div class="flex flex-row mt-4 md:w-max">
            <button (click)="result = null; amount = 0" class="btn w-max mr-2">
               <fa-icon icon="arrow-left"></fa-icon>
               Volver
            </button>
            <button (click)="pay()"
               [disabled]="!amount || amount <= 0 || amount >= 20000"
               class="btn btn-blue flex-1">
               Pagar
               <fa-icon icon="hand-holding-usd"></fa-icon>
            </button>
         </div>
      </div>
   </div>
</div>